import { ModuleConfig } from '@/types/global'

export class ConfigService {
  private config: ModuleConfig = {
    apiConfig: {
      baseUrl: null,
      bearerToken: null,
      clientHost: null,
      systemUid: null,
    },
  }

  setConfig(config: ModuleConfig) {
    this.config = {
      ...this.config,
      ...config,
    }
  }

  getConfig(): ModuleConfig {
    return this.config
  }
}

export const configService = new ConfigService()
